import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { UiTooltipService, UiTooltipPlacement } from './ui-tooltip.service';

/**
 * A simple directive for adding tooltips to elements using the UiTooltipService.
 * 
 * Usage:
 * <button [uiTooltip]="'Mark as done'">...</button>
 * <button [uiTooltip]="'Skip this step'" uiTooltipPlacement="top">...</button>
 */
@Directive({
  selector: '[uiTooltip]',
  standalone: true
})
export class UiTooltipDirective implements OnDestroy {
  @Input('uiTooltip') tooltipText: string = '';
  @Input() uiTooltipPlacement: UiTooltipPlacement = 'top';
  @Input() uiTooltipDelay: number = 200;
  @Input() uiTooltipSuppressOnMobile: boolean = true;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private tooltipService: UiTooltipService
  ) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (!this.tooltipText) return;
    
    this.tooltipService.show({
      content: this.tooltipText,
      element: this.elementRef.nativeElement,
      placement: this.uiTooltipPlacement,
      delay: this.uiTooltipDelay,
      suppressOnMobile: this.uiTooltipSuppressOnMobile,
      displayMode: this.getDisplayMode()
    });
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.tooltipService.hide();
  }

  ngOnDestroy(): void {
    this.tooltipService.hide();
  }

  private getDisplayMode(): 'light' | 'dark' {
    const element = this.elementRef.nativeElement;

    if (element.closest('.theme-light')) {
      return 'light';
    }

    return 'dark';
  }
}
